import { Trip } from 'store/types';
import { createAction } from 'typesafe-actions';

export const setAvailableTrips = createAction(
  'SET_AVAILABLE_TRIPS_STORE',
  ({ departureTrip, returnTrip }: { departureTrip: Trip | null; returnTrip: Trip | null }) => ({
    departureTrip,
    returnTrip,
  }),
)<{ departureTrip: Trip | null; returnTrip: Trip | null }>();

export const clearAvailableTrips = createAction('CLEAR_AVAILABLE_TRIPS_STORE')<undefined>();
